import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonService } from 'src/app/utilities/common-service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
})
export class AboutUsComponent implements OnInit {

  logoImage = 'assets/login/flexremit.svg';
  data: any;

  constructor(private drawerRef: NzDrawerRef, private authService: AuthService, private modalService: NzModalService, private commonService: CommonService ,private message: NzNotificationService) { }

  ngOnInit() {
    this.getAttachment();

  }
  close() {
    this.drawerRef.close();
  }
  getAttachment() {
    this.authService.getUserGuide().subscribe((response: any) => {
      if (response.data && response.data.userGuides[0].id) {
        var attachmentParams = {
          referenceId: response.data.userGuides[0].id,
          type: 'user-guide',
          code: "attachment",
          pageSize: 1,
          pageIndex: 1,
        }
        this.authService.getAttachment(attachmentParams).subscribe((response: any) => {
          this.data = {
            createdBy: response.data.attachments[0].createdByUser.fullName,
            createdDate: response.data.attachments[0].createdDate,
            id: response.data.attachments[0].id,
            filename: response.data.attachments[0].filename,
            referenceId: response.data.attachments[0].referenceId,
            filetype: response.data.attachments[0].filetype,
          };

        })
      }
    })
  }
  // For Download Attachment
  downloadAttachment() {
    if(this.data && this.data.referenceId && this.data.filename){
      this.message.info('Please Wait', 'Loading', {
        nzKey: 'key'
      });
      this.commonService.downloadAttachments(this.data.referenceId, this.data.filename).subscribe((res: any) => {
        let objectURL = URL.createObjectURL(res);
        let myImage = new Image();
        myImage.src = objectURL;
        var url = myImage.src;
        var tabOrWindow = window.open(url, '_blank');
        tabOrWindow.focus();
        // const blob = new Blob([response], { type: this.data.filetype });
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = this.data.filename;
        // link.click();
      });
    }else{
      this.modalService.error({
        nzTitle: 'Error',
        nzContent: 'User Guide not found'
      });
    }
   
  }

}
